import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function NewsTicker() {
  const [tickerItems, setTickerItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchTickerData();
    // Refresh every 30 seconds
    const interval = setInterval(fetchTickerData, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchTickerData = async () => {
    try {
      const response = await fetch(`${API_URL}/api/leaderboard/recent-games`);
      const data = await response.json();
      
      if (data.items && data.items.length > 0) {
        setTickerItems(data.items);
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Failed to fetch ticker data:', error);
      setIsLoading(false);
    }
  };

  const anonymizeEmail = (userId) => {
    // userId format: email from Supabase auth
    // Show first 4 characters for real users, or generic "COMMANDER" for fake/missing data
    if (!userId || !userId.includes('@')) {
      // Generate random generic commander names for filler
      const genericNames = [
        'CMDR-Alpha',
        'CMDR-Bravo', 
        'CMDR-Charlie',
        'CMDR-Delta',
        'CMDR-Echo',
        'CMDR-Foxtrot'
      ];
      return genericNames[Math.floor(Math.random() * genericNames.length)];
    }

    const [localPart, domain] = userId.split('@');
    
    // Show first 4 characters (or less if email is shorter)
    const displayChars = localPart.substring(0, Math.min(4, localPart.length));
    const hiddenLength = Math.max(0, localPart.length - 4);
    const stars = '*'.repeat(hiddenLength);
    
    return `${displayChars}${stars}`;
  };

  if (isLoading) {
    return (
      <div className="fixed top-0 left-0 right-0 z-50 bg-black border-b-4 border-red-600 overflow-hidden">
        <div className="py-3 px-6">
          <p className="text-red-500 text-lg font-mono tracking-wider animate-pulse">
            ⚡ GLOBAL THERMO III - LOADING INTELLIGENCE FEED...
          </p>
        </div>
      </div>
    );
  }
  
  // If no games yet, show welcome message instead of blank loading
  if (tickerItems.length === 0) {
    return (
      <div className="fixed top-0 left-0 right-0 z-50 bg-black border-b-4 border-red-600 overflow-hidden">
        <div className="py-3 px-6">
          <p className="text-red-500 text-lg font-mono tracking-wider">
            ⚡ GLOBAL THERMO III - INTELLIGENCE FEED: No recent games detected. Start a new game to begin! ⚡
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-black border-b-4 border-red-600 overflow-hidden shadow-lg">
      <div className="relative h-12 flex items-center">
        {/* Scrolling ticker content */}
        <div className="absolute whitespace-nowrap animate-ticker">
          {/* Duplicate items to create seamless loop */}
          {[...tickerItems, ...tickerItems, ...tickerItems].map((item, index) => (
            <span
              key={`${item.timestamp}-${index}`}
              className="inline-block mx-8 text-red-500 text-base font-mono tracking-wider led-text"
              style={{
                textShadow: '0 0 10px rgba(239, 68, 68, 0.8)',
                fontWeight: '700',
                letterSpacing: '0.1em'
              }}
            >
              <span className="text-red-400">⚡</span>
              {' '}
              <span className="text-red-300">{anonymizeEmail(item.user_id)}</span>
              {' as '}
              <span className="text-red-400 font-bold">{item.country}</span>
              {' '}
              {item.status === 'VICTORY' && '🏆 VICTORIOUS'}
              {item.status === 'DEFEATED' && '💀 DEFEATED'}
              {item.status === 'ONGOING' && '🎮 IN PROGRESS'}
              {item.status.startsWith('WINNING') && `⚔️ ${item.status}`}
              {' after '}
              <span className="text-yellow-400">{item.turns}</span>
              {' turns'}
              {' '}
              <span className="text-red-400">●</span>
            </span>
          ))}
        </div>
      </div>

      <style jsx>{`
        @keyframes ticker {
          0% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(-33.333%);
          }
        }

        .animate-ticker {
          animation: ticker 60s linear infinite;
        }

        .led-text {
          font-variant-numeric: tabular-nums;
          font-feature-settings: 'tnum';
        }

        /* Pause animation on hover */
        .animate-ticker:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
}

export default NewsTicker;
